import { gql } from '@apollo/client';

export const CREATE_NOTIFICATION_MUTATION = gql`
  mutation createNotification(
    $name: String!
    $publishDate: DateTime!
    $expirationDate: DateTime
    $type: String!
    $text: String!
    $notificationCountryIds: [Int!]!
    $notificationStateProvinceIds: [Int!]!
    $notificationUserIds: [Int!]!
    $notificationCustomerIds: [Int!]!
  ) {
    createNotification(
      name: $name
      publishDate: $publishDate
      expirationDate: $expirationDate
      type: $type
      text: $text
      notificationCountryIds: $notificationCountryIds
      notificationStateProvinceIds: $notificationStateProvinceIds
      notificationUserIds: $notificationUserIds
      notificationCustomerIds: $notificationCustomerIds
    ) {
      notification {
        id
        name
      }
    }
  }
`;

export const UPDATE_NOTIFICATION_MUTATION = gql`
  mutation editNotification(
    $id: Int!
    $name: String!
    $publishDate: DateTime!
    $expirationDate: DateTime
    $type: String!
    $text: String!
    $notificationCountryIds: [Int!]!
    $notificationStateProvinceIds: [Int!]!
    $notificationUserIds: [Int!]!
    $notificationCustomerIds: [Int!]!
  ) {
    editNotification(
      id: $id
      name: $name
      publishDate: $publishDate
      expirationDate: $expirationDate
      type: $type
      text: $text
      notificationCountryIds: $notificationCountryIds
      notificationStateProvinceIds: $notificationStateProvinceIds
      notificationUserIds: $notificationUserIds
      notificationCustomerIds: $notificationCustomerIds
    ) {
      notification {
        id
        name
      }
    }
  }
`;

export const READ_NOTIFICATION_MUTATION = gql`
  mutation readNotification(
    $id: Int!
  ) {
    readNotification(
      id: $id
    ) {
      success
    }
  }
`;
